import { cacheDom } from '../utils/QuerySelectors.js'
import { openDialog, closeDialog } from '../utils/dialogHelper.js'
import { setCartOpen } from '../apps/store/cartSlice'
import store from '../apps/store/store'

const state = {
  mobileMenuOpen: false,
  desktopMenuOpen: false,
  searchOpen: false,
  searchOpener: null,
}
const dom = {}
const qs = {
  mobilePanel: 'data-mobile-panel',
  mobilePanelInner: 'data-mobile-panel-inner',
  mobileNav: 'data-mobile-nav',
  searchPanel: 'data-search-panel',
  searchBackdrop: 'data-search-backdrop',
  searchForm: 'data-search-form',
  bannerClose: 'data-banner-close',
  accountNav: 'data-header-account-nav',
  footer: 'data-footer',
  wishlistLoginHtml: 'data-wishlist-login',
  announcementSlider: 'data-header-announcement',
}
const qsAll = {
  parents: 'data-parent-handle',
  panels: 'data-desktop-panel',
  mobileBtns: 'data-header-mobile-btn',
  searchBtns: 'data-header-search',
  cartBtns: 'data-cart-open',
  accountBtns: 'data-header-account',
  wishlistBtns: 'data-see-wishlist',
  children: 'data-second-child',
}

const scrollEvent = () => {
  const offSet = location.pathname == '/' ? 450 : 80
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  if (scrollTop > offSet) document.body.classList.add('header-sticky')
  else document.body.classList.remove('header-sticky')
  // if(state.desktopMenuOpen || state.mobileMenuOpen) dom.stickyHeader.classList.add('header-sticky')
}

const openMobilePanel = () => {
  dom.mobilePanel.classList.add('z-50', '!opacity-100', '!block')
  dom.mobilePanel.classList.remove('z-[-1]', 'opacity-0')

  dom.mobilePanelInner.classList.add('left-0')
  dom.mobilePanelInner.classList.remove('left-[-20rem]')

  document.body.classList.add('overflow-hidden')
  document.body.classList.add('header-sticky')

  dom.mobileNav.classList.add('flex')
  dom.mobileNav.classList.remove('hidden')

  state.searchOpen = false
  toggleSearch()
  dom.mobileBtns.forEach((btn) => {
    btn.innerHTML = `${window.globalIcons['icon-close']}Close`
    btn.classList.add('active')
  })
  dom.header.classList.add('menu-opened')
  state.mobileMenuOpen = true
}
const closeMobilePanel = () => {
  dom.mobilePanel.classList.remove('z-50', '!opacity-100', '!block')
  dom.mobilePanel.classList.add('z-[-1]', 'opacity-0')

  dom.mobilePanelInner.classList.remove('left-0')
  dom.mobilePanelInner.classList.add('left-[-20rem]')

  document.body.classList.remove('overflow-hidden')
  document.body.classList.remove('header-sticky')
  dom.header.classList.remove('menu-opened')

  dom.mobileBtns.forEach((btn) => {
    btn.innerHTML = 'Menu'
    btn.classList.remove('active')
  })
  dom.mobileNav.classList.remove('flex')
  dom.mobileNav.classList.add('hidden')

  if (state.searchOpen) {
    state.searchOpen = false
    toggleSearch()
  }

  state.mobileMenuOpen = false
}

const closeSearch = () => {
  if (!state.searchOpen) return
  state.searchOpen = false
  toggleSearch()
}

const toggleSearch = () => {
  dom.searchPanel.classList.toggle('!block', state.searchOpen)
  dom.searchPanel.classList.toggle('!z-50', state.searchOpen)
  dom.searchPanel.classList.toggle('!opacity-100', state.searchOpen)
  dom.header.classList.toggle('menu-opened', state.searchOpen)
  if (dom.searchBackdrop) {
    dom.searchBackdrop.classList.toggle('!z-30', state.searchOpen)
    dom.searchBackdrop.classList.toggle('!opacity-100', state.searchOpen)
  }
  if (state.searchOpen) {
    openDialog(dom.searchPanel, state.searchOpener, { onClose: closeSearch })
    if (dom.searchBackdrop) dom.searchBackdrop.removeAttribute('inert')
    dom.mobileBtns.forEach((btn) => {
      btn.innerHTML = `${window.globalIcons['icon-close']}Close`
      btn.classList.add('active')
    })
  } else {
    closeDialog(state.searchOpener)
    if (dom.searchBackdrop) dom.searchBackdrop.setAttribute('inert', '')
    dom.mobileBtns.forEach((btn) => {
      btn.innerHTML = `${window.globalIcons['icon-hamburger']}Menu`
      btn.classList.remove('active')
    })
  }
  dom.searchBtns.forEach((searchBtn) => searchBtn.classList.toggle('opacity-50', state.searchOpen))
}

const resizeEvent = () => {
  // window.innerWidth >= 1024 ? closeMobilePanel() : closeDesktopPanel()
  if (state.desktopMenuOpen || state.mobileMenuOpen) document.body.classList.add('overflow-hidden')
}

const adjustPanels = () => {
  dom.panels.forEach((panel) => {
    const parentLink = panel.closest(`[${qsAll.parents}]`).querySelector('[data-parent-link]')
    panel.querySelector('[data-desktop-panel-list]').style = `margin-left: ${parentLink.offsetLeft}px`
  })
}

const iObserver = new IntersectionObserver((items) => {
  if (items[0].isIntersecting && window.innerWidth < 1024) {
    dom.headerContainer.style.display = 'none'
  } else {
    dom.headerContainer.style.display = ''
  }
})

const adjustHeight = () => {
  const height = document.querySelector('#shopify-section-header').offsetHeight
  document.querySelector('#MainContent').style.marginTop = `${height}px`
}

const openDesktop = (parent) => {
  parent.querySelector('[data-parent-link]').classList.add('!underline')
  state.desktopMenuOpen = true
  dom.panels.forEach((panel) => {
    panel.classList.add('-z-2', 'opacity-0', 'pointer-events-none')
    panel.classList.remove('z-40')
  })
  const panel = parent.querySelector(`[${qsAll.panels}]`)
  panel.classList.remove('-z-2', 'opacity-0', 'pointer-events-none')
  panel.classList.add('z-40')
  state.searchOpen = false
  toggleSearch()
  dom.header.classList.add('menu-opened')
}

const closeDesktop = (parent = null) => {
  if (parent) parent.querySelector('[data-parent-link]').classList.remove('!underline')
  else {
    dom.parents.forEach((p) => p.querySelector('[data-parent-link]')?.classList?.remove('!underline'))
  }

  dom.header.classList.remove('menu-opened')
  state.desktopMenuOpen = false
  dom.panels.forEach((panel) => {
    panel.classList.add('-z-2', 'opacity-0', 'pointer-events-none')
    panel.classList.remove('z-40')
  })
}

const closeAccountPanel = () => {
  dom.accountNav.classList.remove('!opacity-100')
  dom.accountNav.classList.remove('!z-[1]')
  dom.accountNav.classList.remove('!pointer-events-auto')
  dom.accountNav.classList.remove('lg:!grid')
  dom.accountBtns.forEach((accountBtn) => accountBtn.setAttribute('aria-expanded', false))
}

export const setupHeader = () => {
  cacheDom(dom, qs, qsAll)
  dom.header = document.querySelector('#shopify-section-header')
  dom.headerContainer = document.querySelector('[data-header-container]')
  window.addEventListener('scroll', scrollEvent)

  // Margin top for the main section
  adjustHeight()
  window.addEventListener('resize', adjustHeight)

  // Desktop
  new SV.HoverIntent(dom.parents, {
    onEnter: function (parent) {
      openDesktop(parent)
    },
    onExit: function (parent) {
      closeDesktop(parent)
    },
    exitDelay: 400,
    interval: 100,
    sensitivity: 7,
  })
  dom.parents.forEach((parent) => {
    parent.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })
  dom.children.forEach((child) => {
    child.addEventListener('focus', () => {
      const parent = child.closest('[data-parent-handle]')
      openDesktop(parent)
    })
  })
  const headerActions = document.querySelectorAll('.header-action')
  headerActions.forEach((headerAction) => {
    headerAction.addEventListener('focus', () => {
      closeDesktop()
    })
  })

  adjustPanels()

  // Mobile
  dom.mobileBtns.forEach((mobileBtn) => {
    mobileBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      mobileBtn.classList.toggle('active')
      if (mobileBtn.classList.contains('active')) {
        mobileBtn.innerHTML = `${window.globalIcons['icon-close']}Close`
        openMobilePanel()
      } else {
        mobileBtn.innerHTML = `${window.globalIcons['icon-hamburger']}Menu`
        closeMobilePanel()
        state.searchOpen = false
        toggleSearch()
      }
      dom.mobileBtns.forEach((btn) => {
        if (mobileBtn.classList.contains('active')) {
          btn.innerHTML = `${window.globalIcons['icon-close']}Close`
          btn.classList.add('active')
        } else {
          btn.innerHTML = `${window.globalIcons['icon-hamburger']}Menu`
          btn.classList.remove('active')
        }
      })
    })
  })
  dom.mobilePanel.addEventListener('click', () => {
    closeMobilePanel()
  })
  dom.mobilePanelInner.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  window.addEventListener(
    'resize',
    () => {
      adjustPanels()
      // window.innerWidth >= 1024 ? closeMobilePanel() : closeDesktopPanel()
      if (state.desktopMenuOpen || state.mobileMenuOpen) document.body.classList.add('overflow-hidden')
    },
    true,
  )

  if (typeof screen.orientation != 'undefined') {
    screen.orientation.addEventListener('change', () => {
      resizeEvent()
    })
  } else {
    window.addEventListener('orientationchange', () => {
      resizeEvent()
    })
  }

  // Search
  dom.searchBtns.forEach((searchBtn) => {
    searchBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      if (state.mobileMenuOpen) closeMobilePanel()
      state.searchOpen = !state.searchOpen
      state.searchOpener = searchBtn
      toggleSearch()
    })
  })
  dom.searchPanel.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  document.body.addEventListener('click', (e) => {
    state.searchOpen = false
    toggleSearch()
  })

  // Cart Buttons
  dom.cartBtns.forEach((cartBtn) => {
    cartBtn.addEventListener('click', () => {
      if (!window.upsellInited) window.updateUpsells()
      store.dispatch(setCartOpen(true))
    })
  })

  // Banner Close
  if (dom.bannerClose) {
    dom.bannerClose.addEventListener('click', (e) => {
      e.target.closest('.header-index-announcement').remove()
      Cookies.set('announcement-banner', true, { expires: 30 })
    })
  }

  // Account Navs
  dom.accountBtns.forEach((accountBtn) => {
    accountBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      state.searchOpen = false
      toggleSearch()

      dom.accountNav.classList.toggle('!opacity-100')
      dom.accountNav.classList.toggle('!z-[1]')
      dom.accountNav.classList.toggle('!pointer-events-auto')
      dom.accountNav.classList.toggle('lg:!grid')
      accountBtn.setAttribute('aria-expanded', dom.accountNav.classList.contains('!opacity-100'))
      dom.accountNav.querySelector('a')?.focus()
    })
  })
  window.addEventListener('click', () => {
    closeAccountPanel()
  })
  dom.accountNav.querySelector('li:last-child a')?.addEventListener('focusout', () => {
    closeAccountPanel()
    dom.accountBtns[0].focus()
  })

  // Hide sticky header on footer
  iObserver.observe(dom.footer)

  // Open Sign In Popup for Wishlist manage
  dom.wishlistBtns.forEach((wishlistBtn) => {
    wishlistBtn.addEventListener('click', () => {
      function focusing() {
        wishlistBtn.focus()
      }
      window.openPopup(dom.wishlistLoginHtml.innerHTML, null, focusing)
      document.querySelector('[data-popup-content] [name="customer[email]"]')?.focus()
    })
  })
  if (dom.announcementSlider) {
    const seconds = parseInt(dom.announcementSlider.dataset.headerAnnouncement) * 1000
    new Swiper(dom.announcementSlider, {
      loop: true,
      autoplay: seconds > 0 ? { delay: seconds } : false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
}
